/* One existing Studio instance, loaded from the chosen product's own page.
   Reuses product configuration and cart behavior; never copies a different bag's settings. */
(() => {
  document.querySelectorAll('[data-bcc-build]').forEach((page) => {
    if (page.dataset.ready) return;
    page.dataset.ready = 'true';
    const host = page.querySelector('[data-bcc-build-host]');
    const status = page.querySelector('[data-bcc-build-status]');
    let pending = false;
    let currentId = null;
    page.addEventListener('click', async (event) => {
      const card = event.target.closest('[data-bcc-build-product]');
      if (!card || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (pending) return;
      const id = card.dataset.bccBuildProduct;
      const open = () => {
        const trigger = host.querySelector('[data-bcc-open-studio]');
        if (!trigger) throw new Error('Studio could not be opened.');
        trigger.click();
        const dialog = document.querySelector('.bcc-studio-dialog[open]');
        if (!dialog) throw new Error('Studio could not be opened.');
        dialog.addEventListener('close', () => card.focus({preventScroll:true}), {once:true});
      };
      if (currentId === id && host.querySelector('[data-bcc-studio-root]')) { open(); return; }
      pending = true;
      card.setAttribute('aria-busy','true');
      status.textContent = 'Opening your bag in the Studio…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const url = new URL(card.href, location.href);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) throw new Error('This bag could not load.');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const root = doc.querySelector('[data-bcc-studio-root]');
        if (!root || root.dataset.baseProductId !== id) throw new Error('The Studio for this bag is not available yet.');
        host.dispatchEvent(new CustomEvent('shopify:section:unload',{bubbles:true}));
        host.replaceChildren(document.importNode(root,true));
        host.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true}));
        open();
        currentId = id;
        status.textContent = '';
      } catch (error) {
        currentId = null;
        status.textContent = error.name === 'AbortError' ? 'This is taking longer than expected. Try again, or ' : 'We could not open this Studio. Try again, or ';
        const fallback = document.createElement('a');
        fallback.href = card.href; fallback.textContent = 'view this bag'; status.append(fallback,'.');
      } finally {
        clearTimeout(timeout); pending=false; card.removeAttribute('aria-busy');
      }
    });
  });
})();
